module.exports = __webpack_public_path__ + "images/emoji/pouting_cat.450c302f24034cab5eb7.png";